// Session ADU (Director Ask A): a dismissible nudge on the engineer PWA home pointing engineers at
// /engineer/install, so an engineer who lands in a browser is told how to add the app to their home
// screen. Follows the PWA's card idiom (rounded-ele border border-ele-purple-accent bg-ele-surface) and
// the house brand colours; 44px touch targets; laid out to not overflow at 320/375/430px.
//
// It suppresses itself when the app is ALREADY installed (running standalone) and once dismissed
// (persisted), so it never nags an engineer who has done what it asks. See src/lib/pwaInstallNudge.ts.
import { useState } from "react";
import { Link } from "react-router-dom";
import { shouldShowInstallNudge, dismissInstallNudge } from "../../lib/pwaInstallNudge";

export function InstallNudge() {
  // Resolved once on mount: standalone/dismissed state does not change within a session in a way the
  // engineer needs re-evaluated live (installing is a browser action that reloads the app).
  const [show, setShow] = useState(shouldShowInstallNudge);
  if (!show) return null;

  function dismiss() {
    dismissInstallNudge();
    setShow(false);
  }

  return (
    <section
      className="mb-4 rounded-ele border border-ele-green bg-ele-surface p-4"
      aria-label="Install the app"
    >
      <div className="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
        <div className="min-w-0">
          <p className="font-heading text-base tracking-wide text-ele-strong">Add this app to your home screen</p>
          <p className="mt-1 text-sm text-ele-body">
            It opens like an app and keeps working on site, even with no signal.
          </p>
        </div>
        <div className="flex flex-shrink-0 items-center gap-2">
          <Link
            to="/engineer/install"
            className="flex min-h-[44px] items-center rounded-ele bg-ele-green px-4 font-heading tracking-wide text-ele-bg"
          >
            How to install
          </Link>
          <button
            type="button"
            onClick={dismiss}
            className="flex min-h-[44px] items-center rounded-ele border border-ele-field-border px-4 font-menu text-xs tracking-wide text-ele-body hover:text-ele-strong"
          >
            Dismiss
          </button>
        </div>
      </div>
    </section>
  );
}
